import React from 'react'
import TabMenuItem from './TabMenuItem'
import classNames from 'classnames'
import { isUndefined } from 'lodash'

type TabMenuOption = {
  name: string
  to: string
  visible?: boolean
}

type Props = {
  options: TabMenuOption[]
  condensed?: boolean
}

const TabMenu = (props: Props): JSX.Element => {
  const { options, condensed = true } = props
  return (
    <div
      className={classNames(`flex flex-row w-full border-b-2 relative pb-3`, {
        'flex-nowrap': condensed,
      })}>
      {options
        ?.filter((opt) => opt.visible || isUndefined(opt.visible))
        ?.map((option, index) => (
          <TabMenuItem index={index} to={option.to} key={option.to}>
            <div className="w-full h-fit h-full">{option.name}</div>
          </TabMenuItem>
        ))}
    </div>
  )
}

export default TabMenu
